import { useIntersectionObserver } from "@react-hookz/web";
import { useAtom } from "jotai";
import type { RefObject } from "react";
import { useEffect } from "react";
import { graphql, useFragment } from "react-relay";

import { useCurrentArticleIds } from "~/lib/current-item";
import type { hooksHeaderOpinionArticle$key } from "~/queries/__generated__/hooksHeaderOpinionArticle.graphql";

import { opinionHeaderAtom } from "./atoms";

export const useOpinionHeaderObserver = (
  reference: hooksHeaderOpinionArticle$key,
  containerReference: RefObject<HTMLDivElement>,
) => {
  const article = useFragment(
    graphql`
      fragment hooksHeaderOpinionArticle on Article {
        entityUuid
      }
    `,
    reference,
  );
  const { currentArticleUuid } = useCurrentArticleIds();
  const isOnCurrentArticleOpinionHeader = currentArticleUuid === article?.entityUuid;

  const intersectionObserver = useIntersectionObserver(containerReference, {
    threshold: [0.1],
  });
  const [opinionHeader, setOpinionHeader] = useAtom(opinionHeaderAtom);
  useEffect(() => {
    if (
      isOnCurrentArticleOpinionHeader &&
      opinionHeader?.isShowingOpinionHeaderContainer !== intersectionObserver?.isIntersecting
    ) {
      setOpinionHeader({
        isShowingOpinionHeaderContainer: intersectionObserver?.isIntersecting ?? false,
      });
    }
  }, [
    isOnCurrentArticleOpinionHeader,
    intersectionObserver?.isIntersecting,
    opinionHeader,
    setOpinionHeader,
  ]);
};
